export default __webpack_public_path__ + "static/media/Happy Easter.6ab04017.jpg";